import React, { useState, useEffect } from 'react';
import { Bell, X, Check, XCircle } from 'lucide-react';
import axios from 'axios';

const Notifications = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNotifications();
    // Обновляем уведомления каждые 30 секунд
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchNotifications = async () => {
    try {
      const [invitationsResponse, countResponse] = await Promise.all([
        axios.get('/api/collaboration/invitations'),
        axios.get('/api/collaboration/notifications/count')
      ]);
      
      setNotifications(invitationsResponse.data);
      setCount(countResponse.data.count);
    } catch (error) {
      console.error('Ошибка получения уведомлений:', error);
    }
  };

  const handleAccept = async (invitationId) => {
    setLoading(true);
    try {
      await axios.post(`/api/collaboration/invitations/${invitationId}/accept`);
      await fetchNotifications();
    } catch (error) {
      console.error('Ошибка принятия приглашения:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDecline = async (invitationId) => {
    setLoading(true);
    try {
      await axios.post(`/api/collaboration/invitations/${invitationId}/decline`);
      await fetchNotifications();
    } catch (error) {
      console.error('Ошибка отклонения приглашения:', error);
    } finally {
      setLoading(false);
    }
  };

  const getProjectTypeText = (type) => {
    return type === 'faq' ? 'FAQ' : 'Руководство';
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        title="Уведомления"
      >
        <Bell className="h-4 w-4" />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
            {count}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-lg border dark:border-gray-700 z-50">
          <div className="p-4 border-b dark:border-gray-700">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Уведомления
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>

          <div className="max-h-96 overflow-y-auto">
            {notifications.length === 0 ? (
              <div className="p-4 text-center text-gray-500 dark:text-gray-400">
                Нет новых уведомлений
              </div>
            ) : (
              notifications.map((notification) => (
                <div
                  key={notification._id}
                  className="p-4 border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                  <div className="flex items-start space-x-3">
                    <div className="flex-1">
                      <p className="text-sm text-gray-900 dark:text-white">
                        <span className="font-medium">{notification.fromUser.username}</span> пригласил вас в проект{' '}
                        <span className="font-medium">{getProjectTypeText(notification.projectType)}</span>
                      </p>
                      {notification.message && (
                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                          {notification.message}
                        </p>
                      )}
                      <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                        {new Date(notification.createdAt).toLocaleString('ru-RU')}
                      </p>
                    </div>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => handleAccept(notification._id)}
                        disabled={loading}
                        className="p-1 text-green-600 hover:text-green-700 hover:bg-green-50 dark:hover:bg-green-900/20 rounded"
                        title="Принять"
                      >
                        <Check className="h-4 w-4" />
                      </button>
                      <button
                        onClick={() => handleDecline(notification._id)}
                        disabled={loading}
                        className="p-1 text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded"
                        title="Отклонить"
                      >
                        <XCircle className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
